export var GlobalNavigation = /*#__PURE__*/function (GlobalNavigation) {
  GlobalNavigation["LEGACY"] = "legacy";
  GlobalNavigation["NAME"] = "global_navigation";
  GlobalNavigation["PROGRESSIVE_DISCLOSURE"] = "progressive_disclosure";
  return GlobalNavigation;
}({});